<template>
    <swiper 
        :slidesPerView="1.08"
        :spaceBetween="10"
        :pagination="{dynamicBullets: true, clickable: true,}"
        :breakpoints="{
            '769': {
            slidesPerView: 2,
            spaceBetween: 20,
            },
            '1300': {
            slidesPerView: 3,
            spaceBetween: 20,
            },
        }"
        :modules="modules"
        class="mySwiper"          
        ref="swiperBlogs" 
        style="--swiper-pagination-color: black; 
                --swiper-pagination-bullet-inactive-color: black;
                --swiper-pagination-bullet-size: 12px;
                --swiper-pagination-bottom:0px">
        <swiper-slide v-for="(post, index) in posts" :key="index">
            <PostListItem :posts="post" :homepage="false"/>
        </swiper-slide>
    </swiper>
</template>
  
<script lang="ts">
import { mapState } from 'pinia';
import { localeStore } from 'stores/locale';
import translateMain from 'tradutors/menu';
import PostListItem from 'src/components/HomePage/PostListItem.vue'

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

// import required modules
import { Pagination } from 'swiper';

export default {
    name: 'CardsBlogMobile',
    components: { PostListItem, Swiper, SwiperSlide },
    data() {
        return {
            modules: [Pagination],
        };
    },
    props: ['posts'],
    computed: {
        ...mapState(localeStore, ['locale']),
        'translateMain': function () {
            if (this.locale === 'pt-br') {
                return translateMain.portugues
            } else {
                return translateMain.ingles
            }
        },
    },
    methods: {}
}
</script>
<style scoped>
.swiper {
  width: 100%;
}

.swiper-slide {
  font-size: 18px;
  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
}


>>> .card {
    width:100%;
}
>>> .card img {
    width: 290px;
    height: 164px;
}

@media screen and (max-width: 1300px) {
    >>> .card img {
        width: 100%;
        height: unset;
    }    
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
    .swiper-slide {
        width: 319px !important;
        left: 0%;
        margin-right: 12px !important;
    }
}

</style>